export default __webpack_public_path__ + "static/media/wrongSound.d89d88e0.mp3";